module.exports = "\n*:focus {\n    -webkit-box-shadow: 0 0 0 1px white, 0 0 0 3px black, 0 0 0 4px white;\n            box-shadow: 0 0 0 1px white, 0 0 0 3px black, 0 0 0 4px white;\n    z-index: 1;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/component1/component1.component.css
// module id = ./src/app/component1/component1.component.css
// module chunks = main